import React from "react";

import "../../../../styles/css/App.css";

import { Grid } from "@material-ui/core";
import CircularProgress from '@mui/material/CircularProgress';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from '@mui/material/Checkbox';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import * as Constants from "../../../../consts/Constants.js";

import alerter from "../../../alerts/alerter";
import CategoryForm from "./new-category-form";
import { NoticeCategory } from '../../../../plas/services/notices/models';

import service from '../../../../plas/services/notices/service';

export default function Categories() {
  
  const theme = createTheme({
    palette: {
      primary: {
        main: '#FFFFFF',
        darker: '#FFFFFF',
      }
    },
  });

  const [categories, setCategories] = React.useState([]);
  const [category, setCategory] = React.useState(null);

  const [loading, setLoading] = React.useState(false);
  const [saving, setSaving] = React.useState(false);

  const [newCategory, setNewCategory] = React.useState(null);
  const [creating, setCreating] = React.useState(false);
  const [openDialog, setOpenDialog] = React.useState(false);

  React.useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = (placeCategory) => {
    setLoading(true);
    service.api.categories.get(true, (response) => {
      if (response.error != null) {
        alerter.showError(response.error);
      } else {

        response.result.forEach((item) => {
          item.subCategories.forEach((subItem) => {
            subItem.mainCategory = item;
          });
        });

        setCategories(response.result);
        setLoading(false);
      }
    });
  }

  const changeActivate = (category) => {
    let simpleCategory = new NoticeCategory();
    simpleCategory.copySimple(category);
    simpleCategory.activated = !simpleCategory.activated;

    setSaving(true);
    service.api.categories.update(simpleCategory, (response) => {
      if (response.error != null) {
        alerter.showError(response.error);
      } else {
        category.activated = response.result.activated;
        category.name = response.result.name;
      }
      setSaving(false);
    })
  }

  const closeDialog = () => {
    setOpenDialog(false);
  }

  const createCategoryButtonClick = () => {
    let aux = new NoticeCategory();
    setNewCategory(aux);
    setOpenDialog(true);
  }

  const createSubCategoryButtonClick = () => {
    let aux = new NoticeCategory();
    aux.mainCategoryId = category.id;
    setNewCategory(aux);
    setOpenDialog(true);
  }

  const create = () => {
    setCreating(true);
    service.api.categories.create(newCategory, (response) => {
      if (response.error != null) {
        alerter.showError(response.error);
      } else {
        let aux = response.result;
        if (aux.mainCategoryId) {
          categories.forEach((item) => {
            if (item.id === aux.mainCategoryId) {
              item.subCategories.push(aux);
              item.subCategories.sort((itemA, itemB) => { return itemA.name.localeCompare(itemB.name) } );
              aux.mainCategory = item;
            }
          });
        } else {
          let list = [...categories, aux];
          list.sort((itemA, itemB) => { return itemA.name.localeCompare(itemB.name) } );
          setCategories(list);
        }
        setOpenDialog(false);
      }
      setCreating(false);
    });
  }

  const ColoredLine = ({ color, marginTop, marginBottom }) => (
      <hr
        style={{
          color: color,
          backgroundColor: color,
          marginTop: marginTop !== undefined ? marginTop : 6,
          marginBottom: marginBottom !== undefined ? marginBottom : 16,
          height: 2
        }}
      />
  );

  return (
    <div>
      <Grid container>
        <Grid item xs={false} md={2} />
        <Grid item xs={12} md={8} >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <p style={{ fontSize: '28px', textAlign: 'left'}}>
                Categorías
              </p>
              <ColoredLine color="gray" marginTop={0} marginBottom={0} />
            </Grid>
            <Grid item xs={12}>
              { loading ? (
                <CircularProgress style={{color:Constants.COLOR_PRIMARY}} color="inherit" />
              ) : (
                  <Grid container spacing={4}>
                    <Grid item xs={12} sm={6}>
                      <Grid container spacing={2}>
                        <Grid item xs={true}>
                          <Box
                            display="flex"
                            alignItems="center"
                            height="100%">
                            <span style={{ fontSize: '20px', textAlign: 'left'}}>
                            Principales
                            </span>
                          </Box>
                        </Grid>
                        <Grid item>
                          <ThemeProvider theme={theme}>
                            <Button
                              startIcon={<AddRoundedIcon />}
                              variant="contained"
                              onClick={createCategoryButtonClick}>
                              <b>Nueva</b>
                            </Button>
                          </ThemeProvider>
                        </Grid>
                        <Grid item xs={12}>
                          <Grid container>
                            <Grid item>
                              Nombre
                            </Grid>
                            <Grid item xs={true}/>
                            <Grid item>
                              Activada
                            </Grid>
                          </Grid>
                          <List dense>
                            { categories.map((item) => (
                            <ListItem
                              key={item.id}
                              button={true}
                              selected={category === item}
                              onClick={() => setCategory(item)}>
                              <ListItemText id={item.id} primary={item.name} />
                              <ListItemSecondaryAction>
                                <Checkbox
                                  edge="end"
                                  disabled={saving}
                                  onChange={() => changeActivate(item)}
                                  checked={item.activated}
                                />
                              </ListItemSecondaryAction>
                            </ListItem>
                            ))}
                          </List>
                        </Grid>
                      </Grid>
                    </Grid>
                    { category && (
                      <Grid item xs={12} sm={6}>
                        <Grid container spacing={2}>
                          <Grid item xs={true}>
                            <Box
                              display="flex"
                              alignItems="center"
                              height="100%">
                              <span style={{ fontSize: '20px', textAlign: 'left'}}>
                              Subcategorias
                              </span>
                            </Box>
                          </Grid>
                          <Grid item>
                            <ThemeProvider theme={theme}>
                              <Button
                                startIcon={<AddRoundedIcon />}
                                variant="contained"
                                onClick={createSubCategoryButtonClick}>
                                <b>Nueva</b>
                              </Button>
                            </ThemeProvider>
                          </Grid>
                          <Grid item xs={12}>
                             <Grid container>
                              <Grid item>
                                Nombre
                              </Grid>
                              <Grid item xs={true}/>
                              <Grid item>
                                Activada
                              </Grid>
                            </Grid>
                            <List dense>
                              { category && category.subCategories.map((item) => (
                              <ListItem
                                key={item.id}>
                                <ListItemText id={item.id} primary={item.name} />
                                <ListItemSecondaryAction>
                                  <Checkbox
                                    edge="end"
                                    disabled={saving || !item.mainCategory.activated}
                                    onChange={() => changeActivate(item)}
                                    checked={item.activated && item.mainCategory.activated}
                                  />
                                </ListItemSecondaryAction>
                              </ListItem>
                              ))}
                            </List>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={false} md={2} />
      </Grid>

      <Dialog open={openDialog} fullWidth maxWidth="sm" >
        <DialogContent style={{ paddingTop: '16px', paddingBottom: '16px' }}>
          <CategoryForm fullWidth category={newCategory} onCancel={closeDialog} onSave={create} saving={creating}/>
        </DialogContent>
      </Dialog>
    </div>
  );

}